/**
 * Checks if the given value is a valid currency code for Intl.NumberFormat
 *
 * @param value
 */
export const isIntlNumberFormatCurrency = ( value : string ) : boolean => {
    let retVal = false;

    try {
        Intl.NumberFormat( undefined, { style: 'currency', currency: value } ).format( 1 );
        retVal = true;
    }
    catch ( e ) {
        // do nothing since this is only a test
    }

    return retVal;
}

/**
 * Checks if the given value is a valid unit for Intl.NumberFormat
 *
 * @param value
 */
export const isIntlNumberFormatUnit = ( value:string ) : boolean => {
    let retVal = false;

    try {
        // disabled because unit becomes valid NumberFormatOption with ECMA 6
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Intl.NumberFormat( undefined, { style: 'unit', unit: value } ).format( 1 );
        retVal = true;
    }
    catch ( e ) {
        // do nothing since this is only a test
    }

    return retVal;
}
